import React from "react";
import { useNavigate } from "react-router-dom";
import { useHospDocData } from "../../../lib/contexts/HospitalDoctorContext";

const ViewDetails = ({
  mapping_id,
  textStyle,
}: {
  mapping_id?: string;
  textStyle?: string;
}) => {
  const navigate = useNavigate();
  const { hospitalID } = useHospDocData();

  return (
    <button
      className="bg-nextPatient text-white px-3 py-2 rounded hover:bg-blue-400"
      onClick={() => {
        navigate(`/${hospitalID}/doctors/${mapping_id}`);
      }}
    >
      <p
        className={`text-sm hidden md:flex truncate ${
          textStyle ? textStyle : ""
        }`}
      >
        View Details
      </p>
      <p className={`text-sm flex md:hidden ${textStyle ? textStyle : ""}`}>
        Details
      </p>
    </button>
  );
};

export default ViewDetails;
